/* eslint-disable import/prefer-default-export */
import { createAction } from 'redux-actions';

// Action Declarations
// Suggested Action Name Standard: ORG_MODULE_ACTION_ANY
export const getMyDentistListAction = createAction('REFORAL_GET_MY_DENTIST_LIST');
export const deleteAffiliatedDentistAction = createAction('REFORAL_DELETE_AFFILIATED_DENTIST');
export const getAffiliatedDentistReferralsAction = createAction('REFORAL_GET_AFFILIATED_DENTIST_REFERRALS');
export const getUnreadAffiliatedReferralsCountAction = createAction('REFORAL_GET_UNREAD_AFFILIATED_REFERRALS_COUNT');
export const getPreferredDentistReferralAction = createAction('REFORAL_GET_PREFERRED_DENTIST_REFERRAL');
export const getUnreadPreferredDentistReferralsCountAction = createAction('REFORAL_GET_UNREAD_PREFERRED_DENTIST_REFERRALS_COUNT');
export const getClinicReferralFilterDentistListAction = createAction('REFORAL_GET_CLINIC_REFERRAL_FILTER_DENTIST_LIST');
export const getClinicReferralFilterListAction = createAction('REFORAL_GET_CLINIC_REFERRAL_FILTER_LIST');

export const updateMyNewDentistsCountAction = createAction('REFORAL_UPDATE_MY_NEW_DENTISTS_COUNT');
